import React from "react";
import { Link } from "react-router-dom";
import AdminOnlyRoute from "../components/AdminOnlyRoute/AdminOnlyRoute";

const ARCHIVE_ITEMS = [
  {
    to: "/plan",
    icon: "📅",
    title: "Plan",
    hint: "14-Tage-Aktivitätenplan (nicht gepflegt)",
  },
  {
    to: "/entdecken",
    icon: "🔍",
    title: "Entdecken",
    hint: "Aktivitäten stöbern & Karte (nicht gepflegt)",
  },
];

export default function ArchivePage() {
  return (
    <AdminOnlyRoute loginRedirect="/">
      <div className="archiv-page">
        <header className="archiv-header">
          <h2 className="archiv-title">Archiv</h2>
          <p className="archiv-subtitle">
            Plan und Entdecken — nur für Admins. Inhalte werden nicht mehr gepflegt.
          </p>
        </header>

        <ul className="archiv-list">
          {ARCHIVE_ITEMS.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className="archiv-list-link">
                <span className="archiv-list-icon" aria-hidden="true">
                  {item.icon}
                </span>
                <span className="archiv-list-body">
                  <span className="archiv-list-title">{item.title}</span>
                  <span className="archiv-list-hint">{item.hint}</span>
                </span>
                <span className="archiv-list-chevron" aria-hidden="true">
                  ›
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </AdminOnlyRoute>
  );
}
